import { TableConfig } from 'src/app/shared/components/generic-table';
import { NO_NAME } from 'src/app/components/constants';
import { WalletRegistryAlertResponse } from './models/wallet-alert-report.models';

export type WalletAlertReportColumnKeys = keyof WalletRegistryAlertResponse | '_summaryOfChanges';

export const WALLET_ALERT_REPORT_NO_DATA_MESSAGE = $localize`:@@noDataDisplayAlertsReport:No se observó variación en los atributos monitoreados para su visualización en el informe.`;

export const getWalletAlertReportTableConfig = (): TableConfig<
  WalletRegistryAlertResponse,
  WalletAlertReportColumnKeys
> => ({
  columns: [
    {
      id: 'document',
      title: $localize`:@@js_document:Documento`,
      hasCustomContent: true,
      maxWidth: '150px',
      minWidth: '135px',
    },
    {
      id: 'name',
      title: $localize`:@@js_name:Nombre`,
      maxWidth: '350px',
      minWidth: '150px',
      getValue: (row) => row.name || NO_NAME,
    },
    {
      id: '_summaryOfChanges',
      title: $localize`:@@summaryOfChanges:Resumen de cambios`,
      width: '1fr',
      minWidth: '195px',
      hasCustomContent: true,
    },
  ],
  expandableRows: true,
  singleExpansion: false,
  rows: { height: '54px' },
  trackByProp: ['registryId', 'document'],
  rowIdFn: (row: WalletRegistryAlertResponse) => `${row.registryId}-${row.document}`
});

export const walletAlertReportTableConfig = getWalletAlertReportTableConfig;
